import { atomFamily } from "recoil";
import { LayoutWindowId } from "../Types/LayoutWindowId";
import { CPPOptPlotConfig } from "../Types/CPPOptPlot";
import { getDefaultVisualizationAtom } from "./Visualizations";
import { Analytic } from "../Types/AnalysisDetails";

export const cppOptPlotConfigsAtom = atomFamily<CPPOptPlotConfig, LayoutWindowId>({
    key: "cppoptPlotConfigs",
    default: () => ({
        ...getDefaultVisualizationAtom(),
        abpModality: "ABP_na",
        icpModality: "ICP_na",
        prxThreshold: 0.25,
        cppoptAlgorithm: Analytic.CPPOpt
    })
})
